module.exports = __webpack_public_path__ + "static/gwpac-3de7cbbf5fc68cf58749b7e1f10f9dd8.jpg";